export enum ContactModule {
    Facility = 1,
    Unit = 2,
    Account = 3,
    Service = 4
}
